import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { numberNanable } from "commons/ultilities/validation";
import { cloneDeep } from "lodash";
import {
  IAddPackingNote,
  IUpdatePackingNote,
} from "mobx-stores/_models/packing-note/packing-note";

import { date, number, string } from "yup";
export const getAddPackingNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddPackingNote> => {
  const resolveCustomerId = () => form?.getControl("customerId").value ?? null;

  return {
    date: {
      gridSize: 6,
      label: "Ngày",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    number: {
      gridSize: 6,
      label: "Số phiếu",
      type: InputType.text,
      validattionYupSchema: string().max(64),
    },
    purchaseOrderId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Đơn đặt hàng",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("order"),
    },
    customerId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Tên giao dịch",
      validattionYupSchema: string().required(),
      metaData: {
        // searchOptionItemsAsync: async (keyword: string) => {
        //   const purchaseOrderId = form.getControl("purchaseOrderId").value;
        //   if (purchaseOrderId) {
        //     const purchaseOrderDetail = await orderBusiness.getById(
        //       purchaseOrderId
        //     );
        //     if (purchaseOrderDetail) {
        //       return [
        //         {
        //           label: purchaseOrderDetail.customer?.dealingName || "",
        //           value: purchaseOrderDetail.customer?.id,
        //         },
        //       ];
        //     }
        //   }
        //   return [];
        // },
      },
    },
    workOrderPOId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Lệnh sản xuất",
      validattionYupSchema: string().required(),
      metaData: {
        searchOptionItemsAsync: async (keyword: string) => {
          const customerId = resolveCustomerId();
          if (!customerId) return [];
          return await workOrderPoBusiness.searchWoPoAsOptionItems(
            keyword,
            customerId,
          );
        },
      },
    },
    kcsPackage: {
      gridSize: 6,
      label: "Người đóng gói",
      type: InputType.text,
      validattionYupSchema: string(),
    },
    kcsTest: {
      gridSize: 6,
      label: "KCS Kiểm",
      type: InputType.text,
      validattionYupSchema: string(),
    },
    items: {
      label: "Chi tiết phiếu đóng gói",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 4,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          // metaData: {
          //   searchOptionItemsAsync: async (keyword: string) => {
          //     const customerId = form.getControl("customerId").value;
          //     if (!customerId) return [];
          //     return await productBussiness.searchProductAsOptionItems(
          //       keyword,
          //       customerId
          //     );
          //   },
          // },
          defaultValue: "",
        },
        amount: {
          label: "Số lượng (pcs)",
          gridSize: 2,
          type: InputType.number,
          validattionYupSchema: number().required().min(0),
          defaultValue: 0,
        },
        netWeight: {
          label: "TL Tịnh (kg)",
          gridSize: 2,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: undefined,
        },
        grossWeight: {
          label: "TL có bì (kg)",
          gridSize: 2,
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: undefined,
        },
        expiredDate: {
          gridSize: 2,
          label: "Hạn tái kiểm",
          type: InputType.datePicker,
          defaultValue: null,
          validattionYupSchema: date().nullable(),
        },
      },
    },
  };
};

export const getEditPackingNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdatePackingNote> => {
  const schema = getAddPackingNoteFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdatePackingNote> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.workOrderId = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };
  return updateSchema;
};
